import React from 'react';
import Box from '@mui/material/Box';
import { translations } from 'src/constants/translations';
import { UserAction } from 'src/components/profileComponents/Users/components/UserAction';
import { appIcon } from 'src/assets';
import { IComplex } from 'src/typings/complexes';
import { usersPageAction } from 'src/components/profileComponents/Users/types';
import { TypeOfRole } from 'src/typings/user';
import { useUser } from 'src/hooks/user';
import { useStyles } from './styles';

export const ComplexOverviewActions: React.FC<{complex: IComplex}> = ({ complex }) => {
  const styles = useStyles();
  const { currentUserRole } = useUser();
  const actionsList: usersPageAction[] = [{
    id: 1,
    name: 'Manage project inventory',
    description: 'Update buildings & units data',
    icon: appIcon.iconTable.default,
    btn: appIcon.iconChevronRight.default,
    link: `/profile/complexes/${complex?.id}/storage`,
    rolesAccess: [TypeOfRole.rootadmin, TypeOfRole.superadmin, TypeOfRole.admin, TypeOfRole.supervisor, TypeOfRole.partner],
  }, {
    id: 2,
    name: 'Manage availability statuses',
    description: 'Edit and set availability statuses',
    icon: appIcon.iconStatusChange.default,
    btn: appIcon.iconChevronRight.default,
    link: `/profile/complexes/${complex?.id}/status`,
    rolesAccess: [TypeOfRole.rootadmin, TypeOfRole.superadmin, TypeOfRole.admin, TypeOfRole.supervisor, TypeOfRole.partner],
  }, {
    id: 3,
    name: 'Manage project users',
    description: 'Assign and remove users',
    icon: appIcon.iconUsers.default,
    btn: appIcon.iconChevronRight.default,
    link: `/profile/complexes/${complex?.id}/assign`,
    rolesAccess: [TypeOfRole.rootadmin, TypeOfRole.superadmin, TypeOfRole.admin, TypeOfRole.supervisor, TypeOfRole.partner],
  }];
  return (
    <Box className={styles.projectOverviewActions}>
      <Box className="title">{translations.projectSettings}</Box>
      <Box className="list">
        { (actionsList.map((action) => {
          if ((currentUserRole && !action.rolesAccess.includes(currentUserRole))) return null;
          return (
            <React.Fragment key={action.id}>
              <UserAction action={action} />
            </React.Fragment>
          );
        }))}
      </Box>
    </Box>
  );
};
